import api from './config';

/**
 * 获取公告列表（用户端）
 * @param {Object} params 查询参数 {page, page_size}
 */
export function getAnnouncements(params = {}) {
  return api.get('/announcements', { params });
}

/**
 * 获取公告详情
 * @param {number} id 公告ID
 */
export function getAnnouncement(id) {
  return api.get(`/announcements/${id}`);
}

/**
 * 创建公告（管理员）
 * @param {Object} data 公告数据
 */
export function createAnnouncement(data) {
  return api.post('/announcements', data);
}

/**
 * 更新公告（管理员）
 * @param {number} id 公告ID
 * @param {Object} data 公告数据
 */
export function updateAnnouncement(id, data) {
  return api.put(`/announcements/${id}`, data);
}

/**
 * 删除公告（管理员）
 * @param {number} id 公告ID
 */
export function deleteAnnouncement(id) {
  return api.delete(`/announcements/${id}`);
}

/**
 * 获取公告列表（管理端，包含草稿）
 * @param {Object} params 查询参数 {page, page_size, status}
 */
export function getAnnouncementsAdmin(params = {}) {
  return api.get('/announcements/admin', { params });
}

